// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.c4fce52e4',
  revision: 'c4fce52e4',
  branch: 'develop',
  date: 'Tue, 12 May 2026 14:31:17 GMT'
};